"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const styles_2 = require("../styles");
const Text_1 = __importDefault(require("./Text"));
const handleBorderColor = (variant = 'default', borderColor = 'default') => {
    if (variant === 'input') {
        if (borderColor === 'default') {
            return borderColors['input'];
        }
    }
    return borderColors[borderColor];
};
const TextView = ({ marginBottom = styles_2.getSpacing(), borderColor = 'default', isSpaceBetween = false, textContainerStyle, iconComponent, placeholder, variant = 'default', elevated = true, title, style, value, valueColor = 'default', }) => {
    const showPlaceHolder = variant === 'input' && !value && placeholder;
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([
            styles.cardContainer,
            { marginBottom },
            handleBorderColor(variant, borderColor),
            backgroundColors[variant],
            style,
        ]) },
        !showPlaceHolder && (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([
                styles.textContainer,
                isSpaceBetween && { justifyContent: 'space-between' },
                textContainerStyle,
            ]) },
            !!title && (react_1.default.createElement(Text_1.default, { style: styles.title, margin: "none", color: "description" },
                title,
                ":")),
            react_1.default.createElement(Text_1.default, { margin: "none", color: valueColor }, value))),
        showPlaceHolder && (react_1.default.createElement(Text_1.default, { color: "description", margin: "none" }, placeholder)),
        !!iconComponent && react_1.default.createElement(react_native_1.View, null, iconComponent)));
};
exports.default = TextView;
const styles = react_native_1.StyleSheet.create({
    cardContainer: {
        borderWidth: styles_2.getSpacing('border'),
        borderColor: styles_1.Colors.border,
        borderRadius: styles_1.getRadius(),
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: styles_2.getSpacing(),
        height: styles_2.getSpacing('row'),
    },
    textContainer: {
        flex: 1,
        flexDirection: 'row',
    },
    title: {
        // flex: 1,
        marginRight: styles_2.getSpacing(0.5),
    },
});
const backgroundColors = react_native_1.StyleSheet.create({
    default: {
        backgroundColor: styles_1.Colors.card,
    },
    input: {
        backgroundColor: styles_1.Colors.lightgrey,
    },
});
const borderColors = react_native_1.StyleSheet.create({
    default: {},
    primary: {
        borderColor: styles_1.Colors.primary,
    },
    secondary: {
        borderColor: styles_1.Colors.secondary,
    },
    input: {
        borderColor: styles_1.Colors.lightgrey,
    },
});
